export default function v1FooterLangNav() {
  const langWraps = document.querySelectorAll('.v1-footerMainNav__langNav');
  if (!langWraps || langWraps.length <= 0) return;
  const url = window.location.pathname;
  const lang = url.replace(/^\/(.*?)\/(.*?)(\/.*?)$/, '$1');
  const country = url.replace(/^\/(.*?)\/(.*?)(\/.*?)$/, '$2');
  const urlStem = url.replace(/^\/(.*?)\/(.*?)(\/.*?)$/, '$3');

  const langCountry = {
    ja: [
      'jp',
      'au',
      'be',
      'ca',
      'ch',
      'cn',
      'es',
      'eur',
      'fr',
      'gb',
      'hk',
      'in',
      'it',
      'kh',
      'kr',
      'mm',
      'mx',
      'my',
      'ph',
      'sg',
      'th',
      'us',
      'vn',
      'at',
      'id',
      'de',
      'tw',
    ],
    en: [
      'jp',
      'au',
      'be',
      'ca',
      'ch',
      'cn',
      'es',
      'eur',
      'fr',
      'gb',
      'hk',
      'in',
      'it',
      'kh',
      'kr',
      'mm',
      'mx',
      'my',
      'ph',
      'sg',
      'th',
      'us',
      'vn',
      'at',
      'id',
      'de',
      'tw',
    ],
    zh: ['cn', 'hk', 'tw'],
    de: ['de', 'at'],
    es: ['mx'],
    fr: ['fr'],
    id: ['id'],
    ko: ['kr'],
    th: ['th'],
    vi: ['vn'],
  };

  const locationText = {
    ja: 'Japanese Page',
    en: 'English Page',
    cn: '简体中文页面',
    hk: '繁體中文頁面',
    tw: '繁體中文頁面',
    kr: '한국어 페이지',
    fr: 'Page en français',
    de: 'Deutsch Seite',
    th: 'หน้าภาษาไทย',
    id: 'Halaman Bahasa Indonesia',
    vn: 'Việt Nam',
    mx: 'Español',
  };

  langWraps.forEach(langWrap => {
    // 相互リンクを初期化
    // eslint-disable-next-line no-param-reassign
    langWrap.textContent = '';

    // 他言語版のページを探して、存在していたら相互リンクに加える
    Object.keys(langCountry).forEach(function langLoop(key) {
      if (key === lang) {
        return true; // 同じ言語ならスキップ
      }

      const thisLang = langCountry[key];

      Object.keys(thisLang).forEach(function thisLoop(langKey) {
        if (thisLang[langKey] === country) {
          const xhr = new XMLHttpRequest();
          const method = 'GET';
          const langUrl = `/${key}/${country}${urlStem}`;
          const linkText = locationText[key] || locationText[country];

          xhr.open(method, langUrl, true);
          xhr.onreadystatechange = function checkUrl() {
            if (xhr.readyState === 4 && xhr.status === 200) {
              // 相互リンクを追加する(日本語リンクのみ、lang="en"とする)
              const link = `<li class="v1-footerMainNav__langItem"><a href="${langUrl}" lang="${
                key === 'ja' ? 'en' : key
              }" class="v1-footerMainNav__langLink">${linkText}</a></li>`;
              langWrap.insertAdjacentHTML('beforeend', link);
            }
          };
          xhr.send();
        }
      });
      return false;
    });
  });
}
